<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="hrissecondary"
        class="white--text px-10" 
        v-on="on"
      >
        Create HRIS Role
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      title="HRIS Role"
      text="Create HRIS role"
      color="hrissecondary"      
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="12"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Role Name"
                outlined
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="12"
            >
              <v-text-field
                v-model="level"
                v-validate="'required|min_value:2|max_value:255'"
                :error-messages="errors.collect('level')"
                data-vv-name="level"
                type="number"
                outlined
                label="Role Level"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text px-10"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        name: null,
        level: 0,
      }
    },
    watch: {
      dialog: {
        immediate: true,
        handler (value) {
          if (value) {
            this.resetForm()
            this.$validator.resume()
          }
        },
      },
    },
    methods: {
      resetForm () {
        this.name = ''
        this.level = 0
        this.$validator.reset()
      },
      setDialog (value = false) {
        this.dialog = value
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      validateForm () {
        return this.$validator.validateAll()
      },    
      submitForm () {
        this.validateForm().then((result) => {
          if (!result) return

          this.setProgressing(true)
  
          this.$api.hrisRoles().create(this.prepareFormData())
            .then((res) => {
              if (res.status === 201) {  
                this.$emit('created')
                this.$snack({
                  message: 'The HRIS role is created successfully',
                })
                this.resetForm() 

                this.$validator.pause()
                this.setDialog(false)                           
              }
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        })
      },
      prepareFormData () {
        return {
          name: this.name,
          level: this.level,
        }
      },
    },

  }
</script>
